var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSeparator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 40,
    viewBox: "0 0 1920 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_2811",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_2811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-199 -53.1626L-120.382 -68.0001L299.272 169.601C308.884 175.043 307.877 181.115 297.023 183.163L257.711 190.583C246.857 192.631 230.266 189.88 220.654 184.438L-199 -53.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 -53.1626L89.6184 -68.0001L509.272 169.601C518.884 175.043 517.877 181.115 507.023 183.163L467.711 190.583C456.857 192.631 440.266 189.88 430.654 184.438L11 -53.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 -53.1626L299.618 -68.0001L719.272 169.601C728.884 175.043 727.877 181.115 717.023 183.163L677.711 190.583C666.857 192.631 650.266 189.88 640.654 184.438L221 -53.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431 -53.1621L509.618 -67.9996L929.272 169.601C938.884 175.043 937.877 181.115 927.023 183.164L887.711 190.583C876.857 192.632 860.266 189.881 850.654 184.438L431 -53.1621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 -53.1626L719.618 -68.0001L1139.27 169.601C1148.88 175.043 1147.88 181.115 1137.02 183.163L1097.71 190.583C1086.86 192.631 1070.27 189.88 1060.65 184.438L641 -53.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851 -53.1626L929.618 -68.0001L1349.27 169.601C1358.88 175.043 1357.88 181.115 1347.02 183.163L1307.71 190.583C1296.86 192.631 1280.27 189.88 1270.65 184.438L851 -53.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061 -53.1621L1139.62 -67.9996L1559.27 169.601C1568.88 175.043 1567.88 181.115 1557.02 183.164L1517.71 190.583C1506.86 192.632 1490.27 189.881 1480.65 184.438L1061 -53.1621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270 -53.1626L1348.62 -68.0001L1768.27 169.601C1777.88 175.043 1776.88 181.115 1766.02 183.163L1726.71 190.583C1715.86 192.631 1699.27 189.88 1689.65 184.438L1270 -53.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480 -53.1626L1558.62 -68.0001L1978.27 169.601C1987.88 175.043 1986.88 181.115 1976.02 183.163L1936.71 190.583C1925.86 192.631 1909.27 189.88 1899.65 184.438L1480 -53.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689 -53.1621L1767.62 -67.9996L2187.27 169.601C2196.88 175.043 2195.88 181.115 2185.02 183.164L2145.71 190.583C2134.86 192.632 2118.27 189.881 2108.65 184.438L1689 -53.1621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 -53.1621L194.618 -67.9996L614.272 169.601C623.884 175.043 622.877 181.115 612.023 183.164L572.711 190.583C561.857 192.632 545.266 189.881 535.654 184.438L116 -53.1621Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 -53.1621L404.618 -67.9996L824.272 169.601C833.884 175.043 832.877 181.115 822.023 183.164L782.711 190.583C771.857 192.632 755.266 189.881 745.654 184.438L326 -53.1621Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94 -53.1626L-15.3816 -68.0001L404.272 169.601C413.884 175.043 412.877 181.115 402.023 183.163L362.711 190.583C351.857 192.631 335.266 189.88 325.654 184.438L-94 -53.1626Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 -53.1626L614.618 -68.0001L1034.27 169.601C1043.88 175.043 1042.88 181.115 1032.02 183.163L992.711 190.583C981.857 192.631 965.266 189.88 955.654 184.438L536 -53.1626Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 -53.1621L824.618 -67.9996L1244.27 169.601C1253.88 175.043 1252.88 181.115 1242.02 183.164L1202.71 190.583C1191.86 192.632 1175.27 189.881 1165.65 184.438L746 -53.1621Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956 -53.1621L1034.62 -67.9996L1454.27 169.601C1463.88 175.043 1462.88 181.115 1452.02 183.164L1412.71 190.583C1401.86 192.632 1385.27 189.881 1375.65 184.438L956 -53.1621Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375 -53.1621L1453.62 -67.9996L1873.27 169.601C1882.88 175.043 1881.88 181.115 1871.02 183.164L1831.71 190.583C1820.86 192.632 1804.27 189.881 1794.65 184.438L1375 -53.1621Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 -53.1626L1243.62 -68.0001L1663.27 169.601C1672.88 175.043 1671.88 181.115 1661.02 183.163L1621.71 190.583C1610.86 192.631 1594.27 189.88 1584.65 184.438L1165 -53.1626Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585 -53.1626L1663.62 -68.0001L2083.27 169.601C2092.88 175.043 2091.88 181.115 2081.02 183.163L2041.71 190.583C2030.86 192.631 2014.27 189.88 2004.65 184.438L1585 -53.1626Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1794 -53.1626L1872.62 -68.0001L2292.27 169.601C2301.88 175.043 2300.88 181.115 2290.02 183.163L2250.71 190.583C2239.86 192.631 2223.27 189.88 2213.65 184.438L1794 -53.1626Z",
    fill: "#0F242F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1861.77 -53.1626L1940.38 -68.0001L2360.04 169.601C2369.65 175.043 2368.64 181.115 2357.79 183.163L2318.48 190.583C2307.62 192.631 2291.03 189.88 2281.42 184.438L1861.77 -53.1626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-278 -38.3247L-199.382 -53.1622L220.272 184.438C229.884 189.881 228.877 195.953 218.023 198.001L178.711 205.421C167.857 207.469 151.266 204.718 141.654 199.276L-278 -38.3247Z",
    fill: "#0F242F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSeparator);
export default __webpack_public_path__ + "static/media/blue_separator.edb921d0360a4ee2904de8fae35122fe.svg";
export { ForwardRef as ReactComponent };